module.exports = __webpack_public_path__ + "img/workorderlist4.efe8d88e.png";